function createButtonStyles(linkStyle) {
  const defaultButtonStyles = {
    color: "primary",
    variant: "solid"
  };
  const styles = linkStyle && linkStyle.split(" ");
  if (!styles || !styles.length) {
    return defaultButtonStyles;
  }
  return {
    color: styles.includes("secondary") ? "secondary" : "primary",
    variant: styles.includes("outline") ? "outline" : "solid"
  };
}
export {
  createButtonStyles
};
//# sourceMappingURL=create-button-styles.js.map
